import React, { ForwardedRef, forwardRef } from "react";
import CheckFilled from "../Icons/CheckFilled";
import CheckOutline from "../Icons/CheckOutline";
import ToggleButton, { TToggleButtonProps, IToggleButton } from "./ToggleButton";
import GUI from "../GUI";

export type TCheckboxProps = Omit<TToggleButtonProps, "onToggle"|"iconChecked"|"iconUnchecked">
export {type IToggleButton}

export default forwardRef((props:TCheckboxProps, ref?:ForwardedRef<IToggleButton>) => {
    const onToggle = (value:boolean) => !value
    const {children,className,...buttonProps} = props
    return <ToggleButton className={GUI.joinClass("checkbox", className)} {...buttonProps} iconChecked={<CheckFilled/>} iconUnchecked={<CheckOutline/>} onToggle={onToggle} ref={ref}>{children}</ToggleButton>
})